import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { useLoaderData, useOutletContext } from "react-router-dom";

import invariant from "tiny-invariant";

import RescheduleGameForm from "./components/RescheduleGameForm";
import { IRescheduleGameData } from "./types/reschedulegame";

import "../../assets/css/majorybl/pages/clubhouse.scss";
import ErrorBoundary from "../../components/ErrorBoundary";
import { selectFields } from "../../features/global/globalSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import {
    IGame,
    ILeague,
    ILeagueSchedule,
    ITeamSchedule,
} from "../../types/api";

const RescheduleGame = (): React.JSX.Element => {
    const { schedule, setSchedule } = useOutletContext() as {
        schedule: IGame[];
        setSchedule: React.Dispatch<React.SetStateAction<IGame[]>>;
    };

    const fields = useAppSelector(selectFields);
    const { leagueId, gameId } = useLoaderData() as {
        leagueId?: ILeague["id"];
        gameId: IGame["id"];
    };

    const user = useAppSelector(state => state.auth.user);

    const game = schedule.find(g => g.id === gameId);

    try {
        invariant(game);
    } catch (error) {
        return <ErrorBoundary error={new Error("Game not found")} />;
    }

    const currentField = fields.find(f => f.id === game?.fieldId);

    const methods = useForm<IRescheduleGameData>({
        mode: "onChange",
        shouldUnregister: true,
        defaultValues: {
            gameId: game.id,
            datetime: new Date(game.date),
            field: {
                value: game.fieldId,
                label: [512, 532].includes(game.fieldId)
                    ? currentField?.name
                    : `${currentField?.name} (${currentField?.city}, ${currentField?.state})`,
            },
            diamond: game?.diamond
                ? {
                      value: game.diamond,
                      label: currentField?.diamonds.find(
                          d => d.id === game.diamond,
                      )?.name,
                  }
                : undefined,
            note: game?.note,
        },
    });

    return (
        <section className="createGameInfo" data-testid="createGameContent">
            <h2>
                {user!.userLevel <= 2
                    ? "Reschedule Game"
                    : game.isPlayoff === 0
                      ? "Propose Reschedule"
                      : "Set Field"}
            </h2>
            <RescheduleGameForm
                methods={methods}
                game={game}
                schedule={schedule}
                setSchedule={setSchedule}
                leagueId={leagueId}
            />
        </section>
    );
};

export default RescheduleGame;
